import React from 'react';

const SZ = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_33"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_33)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#FFDE00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12H21V15H0V12ZM0 0H21V3H0V0Z"
        fill="#4769C1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4H21V11H0V4Z"
        fill="#BC0A33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8H17V9H4V8ZM6 6H16V7H6V6Z"
        fill="#E1C400"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 6H18V7H16V6Z"
        fill="#9D9191"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 10C12.985 10 15 7.5 15 7.5C15 7.5 12.985 5 10.5 5C8.015 5 6 7.5 6 7.5C6 7.5 8.015 10 10.5 10Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 10C11 10 12 7.5 12 7.5C12 7.5 11 5 10.5 5C8.015 5 6 7.5 6 7.5C6 7.5 8.015 10 10.5 10Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 7H9V8H8V7ZM10 7H11V8H10V7Z"
        fill="#878787"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 7H14V8H13V7Z"
        fill="#5B5B5B"
        stroke="#979797"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default SZ;
